import React from "react";
import { Layout, Row, Col, Card, Button, Tag, Rate, Statistic, Typography } from "antd";
import {
  ShoppingCartOutlined,
  UserOutlined,
  TeamOutlined,
  ReadOutlined,
  LineChartOutlined,
} from "@ant-design/icons";

const { Title, Text } = Typography;
const { Content, Footer } = Layout;

// Liste des cours
const courses = [
  {
    title: "Sciences Informatiques",
    description: "Découvrez les bases de la science des données et développez vos compétences techniques.",
    category: "Informatique",
    rating: 4,
    oldPrice: "$60",
    price: "$55",
    image: "/images/courses-small/courses-small1.jpg",
  },
  {
    title: "Robotique Moderne",
    description: "Apprenez à concevoir et développer des systèmes robotiques avancés.",
    category: "Technologie",
    rating: 5,
    oldPrice: "$50",
    price: "$45",
    image: "/images/courses-small/courses-small2.jpg",
  },
  {
    title: "Chimie Générale",
    description: "Explorez les principes fondamentaux de la chimie.",
    category: "Sciences",
    rating: 4,
    oldPrice: "$70",
    price: "$35",
    image: "/images/courses-small/courses-small3.jpg",
  },
];

// Statistiques importantes
const statistics = [
  { title: "Apprenants actifs", value: 1500, icon: <UserOutlined style={{ fontSize: "40px", color: "#1890ff" }} /> },
  { title: "Cours disponibles", value: 200, icon: <ReadOutlined style={{ fontSize: "40px", color: "#1890ff" }} /> },
  { title: "Instructeurs certifiés", value: 50, icon: <TeamOutlined style={{ fontSize: "40px", color: "#1890ff" }} /> },
  { title: "Taux de satisfaction", value: "98%", icon: <LineChartOutlined style={{ fontSize: "40px", color: "#1890ff" }} /> },
];

const HomePage = () => {
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Content style={{ backgroundColor: "#f9f9f9", padding: "20px 0" }}>
        {/* Section 1: Liste des cours */}
        <div style={{ textAlign: "center", marginBottom: "40px" }}>
          <Title level={2} style={{ color: "#004b8d" }}>Apprenez avec les meilleurs instructeurs</Title>
          <Text>Une plateforme e-learning innovante pour explorer, apprendre et réussir.</Text>
        </div>
        <Row gutter={[16, 16]} style={{ marginBottom: "50px", padding: "0 20px" }}>
          {courses.map((course, index) => (
            <Col xs={24} sm={12} md={8} key={index}>
              <Card
                hoverable
                cover={<img alt={course.title} src={course.image} style={{ height: "300px", objectFit: "cover" }} />}
                style={{ borderRadius: "10px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)" }}
              >
                <Tag color="blue">{course.category}</Tag>
                <Title level={4} style={{ color: "#004b8d" }}>{course.title}</Title>
                <Text>{course.description}</Text>
                <div style={{ marginTop: 10 }}>
                  <Rate disabled defaultValue={course.rating} />
                </div>
                <div style={{ marginTop: 10, fontWeight: "bold" }}>
                  <span style={{ textDecoration: "line-through", color: "gray", marginRight: 8 }}>{course.oldPrice}</span>
                  <span style={{ color: "#004b8d" }}>{course.price}</span>
                </div>
                <Button type="primary" block style={{ marginTop: 10, backgroundColor: "#004b8d" }} icon={<ShoppingCartOutlined />}>
                  Acheter ce cours
                </Button>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Section 2: Statistiques importantes */}
        <Row gutter={[16, 16]} style={{ marginBottom: "50px", padding: "0 20px" }}>
          {statistics.map((stat, index) => (
            <Col xs={24} sm={12} md={6} key={index}>
              <Card bordered={false} style={{ textAlign: "center", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)" }}>
                {stat.icon}
                <Statistic title={stat.title} value={stat.value} />
              </Card>
            </Col>
          ))}
        </Row>
      </Content>
      <Footer style={{ textAlign: "center", backgroundColor: "#004b8d", color: "white" }}>
        ©2024 E-Learning. Tous droits réservés.
      </Footer>
    </Layout>
  );
};

export default HomePage;


// import React, { useState, useEffect } from "react";

// import UserService from "../services/user.service";

// const Home = () => {
//   const [content, setContent] = useState("");

//   useEffect(() => {
//     UserService.getPublicContent().then(
//       (response) => {
//         setContent(response.data);
//       },
//       (error) => {
//         const _content =
//           (error.response && error.response.data) ||
//           error.message ||
//           error.toString();

//         setContent(_content);
//       }
//     );
//   }, []);

//   return (
//     <div className="container">
//       <header className="jumbotron">
//         <h3>{content}</h3>
//       </header>
//     </div>
//   );
// };

// export default Home;
